import React from 'react';
import { get2DKeyHandler } from 't-lib-ui/structure';
import { CategoryIcon, categoryColorMap } from './CategoryIcons';
import { formatCategory } from '../utils/formatting';
import './CategoryTile.css';

interface CategoryTileProps {
  category: string;
  onCategoryClick: (category: string) => void;
  small?: boolean;
}

const CategoryTile: React.FC<CategoryTileProps> = ({ category, onCategoryClick, small = false }) => {
  const displayName = formatCategory(category);
  if (!displayName) return null;

  const color = categoryColorMap[category] || 'var(--gray-400)';
  const handleClick = () => onCategoryClick(category);
  const handleKeyDown = get2DKeyHandler(handleClick);

  const iconSize = small ? 18 : 36;

  return (
    <div
      className={`categoryTile flowFocussable flow2d ${small ? 'small' : ''}`}
      style={{ 
        borderColor: color, 
      }}
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      <CategoryIcon category={category} size={iconSize} color={color} />
      <span className="categoryTileName">{displayName.replace(/.*\//, '')}</span>
    </div>
  );
};

export default CategoryTile;
